import CustomPoint from './CustomPoint'

export default CustomPoint